export default __webpack_public_path__ + "static/media/L_Amandier_bleu_grand_porte_cle.cbcf2858.png";